import * as React from 'react';
import {useCallback, useMemo, useState} from 'react';
import {Carousel} from '@baidu/hcui';
import useJumpUrl from '@/hooks/useJumpUrl';
import {TopicModule} from '@/services/pages/channel/channel.client';
import {VALUE_TYPE} from '@/dicts/consts';
import styles from './index.less';

interface Props {
    page: string;
    sfRef?: string;
    channelBusinessLine?: string;
    bannersModel: TopicModule;
}

const DiseaseBannerSwipe = ({bannersModel, page, channelBusinessLine}: Props) => {
    const {navigateToUrl} = useJumpUrl();
    const [loaded, setLoaded] = useState(false);
    const handleBannerClick = useCallback(
        (linkUrl?: string, swanUrl?: string, banner?) => {
            const urlParams = {
                linkUrl,
                swanUrl,
            };
            const logParams = {
                page: page,
                value: 'jump_tupian_lunbotu',
                channelId: bannersModel?.channelId,
                pageType: channelBusinessLine,
                moduleId: bannersModel?.moduleId,
                moduleName: bannersModel?.moduleName,
                customize: {
                    // eslint-disable-next-line camelcase
                    value_type: VALUE_TYPE.ITEM,
                    // eslint-disable-next-line camelcase
                    value_id: banner.itemId,
                    // eslint-disable-next-line camelcase
                    value_title: banner.title,
                },
            };
            navigateToUrl(urlParams, logParams);
        },
        [
            bannersModel.channelId,
            bannersModel.moduleId,
            bannersModel.moduleName,
            channelBusinessLine,
            page,
            navigateToUrl,
        ]
    );


    const ImgStyle = useMemo(
        () => (
            {
                height: loaded ? 'auto' : '400px',
            }
        ),
        [loaded]
    );

    const handleImgLoad = useCallback(
        () => {
            setLoaded(true);
        },
        []
    );

    return (

        <div
            data-show={JSON.stringify({
                'page': page,
                'value': 'jump_tupian_lunbotu',
                'pageSourceId': bannersModel.channelId,
                'pageType': channelBusinessLine,
                'valueId': bannersModel.moduleId,
                'valueTitle': bannersModel.moduleName,
                'valueType': VALUE_TYPE.MODULE,
            })}
            id={bannersModel.moduleId?.toString()}
        >
            {
                (bannersModel.isShowTitle === 1 && (bannersModel.moduleName || bannersModel.moduleSubTitle))
                    ? (
                        <div className={styles.titleParent}>
                            <div className={styles.titleContent}>
                                {
                                    bannersModel.moduleName
                                        ? (
                                            <span className={styles.title}>
                                                {bannersModel.moduleName}
                                            </span>
                                        )
                                        : null
                                }
                                {
                                    bannersModel.moduleSubTitle
                                        ? (
                                            <span className={styles.subTitle}>
                                                {bannersModel.moduleSubTitle}
                                            </span>
                                        )
                                        : null
                                }
                            </div>
                            <div>
                                {
                                    bannersModel.moreUrl
                                        ? (
                                            <img
                                                src={'https://med-fe.cdn.bcebos.com/content-external-channel/rightDirect.png'}
                                                className={styles.rightMoreArrow}
                                                onClick={() => {
                                                    handleBannerClick(bannersModel.moreUrl);
                                                }}
                                            />
                                        )
                                        : null
                                }
                            </div>
                        </div>
                    )
                    : null
            }

            <Carousel
                autoPlayIntervalTime={5000}
                moveDistanceRatio={0}
                autoPlay
                loop={(bannersModel?.itemList?.length || 0) > 1}
                showPagination={(bannersModel?.itemList?.length || 0) > 1}
                style={{
                    fontSize: '0',
                }}
                className={styles.carouselWrap}
            >
                {
                    bannersModel.itemList?.map(
                        banner => (
                            <div
                                id={banner.itemId?.toString()}
                                key={banner.itemId}
                                data-show={JSON.stringify({
                                    'page': page,
                                    'value': 'jump_tupian_lunbotu',
                                    'pageSourceId': banner.channelId,
                                    'pageType': channelBusinessLine,
                                    'valueId': banner.itemId,
                                    'valueTitle': banner.title,
                                    'valueType': VALUE_TYPE.ITEM,
                                })}
                                onClick={() => handleBannerClick(
                                    banner.fieldValue?.link, banner.fieldValue?.swanUrl, banner
                                )}
                            >
                                <img
                                    onClick={() => {}}
                                    src={banner.fieldValue?.img}
                                    className={styles.imgCard}
                                    alt="swiperPng"
                                    style={{
                                        borderRadius: bannersModel.moduleFillet === 1 ? '0' : '12px',
                                        ...ImgStyle,
                                    }}
                                    onLoad={handleImgLoad}
                                />
                            </div>
                        ))
                }

            </Carousel>

        </div>

    );
};

export default React.memo(DiseaseBannerSwipe);
